import { useAssistantWebSocket } from '../../hooks/useAssistantWebSocket';
import { useAuthState } from '../../providers/AuthProvider';

import AssistantPaneView from './AssistantPaneView';

/**
 * Top-level "Mantle Assistant" pane (route `/assistant`). Streams a
 * Claude-backed financial chat over WebSocket. Visibility is gated at the
 * route boundary by `feat-assistant` (`AssistantRouteGate` in `MainApp.tsx`);
 * this pane itself does not re-check that gate.
 *
 * Thin wrapper around {@link AssistantPaneView} — owns the hook, hands its
 * return shape to the presentational view. The split exists so Storybook
 * stories and visual-verification subagents can render the view from fixture
 * data without mocking the hook.
 *
 * Tool-call detail is not rendered. When the `debug-assistant` gate is on, the
 * server streams each tool's name / args / output on the live frames and the
 * hook logs them to the browser console as they complete.
 */
const AssistantPane = () => {
  const { session } = useAuthState();

  // Chat auth is cookie-based — pass a boolean instead of any credential.
  // The browser attaches `_s` to the WS upgrade automatically.
  const { messages, isProcessing, isAbortable, isRehydrating, connectionStatus, error, sendMessage, stopTurn } =
    useAssistantWebSocket(session != null);

  return (
    <AssistantPaneView
      messages={messages}
      isProcessing={isProcessing}
      isAbortable={isAbortable}
      isRehydrating={isRehydrating}
      connectionStatus={connectionStatus}
      error={error}
      onSend={sendMessage}
      onStop={stopTurn}
    />
  );
};

export default AssistantPane;
